<app-public-with-header
  headerImgMobile="/assets/img/headers/dev.m.jpg"
  headerImgDesktop="/assets/img/headers/dev.jpg"
  headingText="meta-tags.api-services.header"
  headingSubText="For developers and their applications"
>
  <div class="flex flex-col font-light developers text-app-grey">
    <div class="mx-auto mb-6 w-10/12 text-center lg:mb-20 lg:w-6/12 dev-header">
      <app-paragraph [paragraph]="apiForTradersP"></app-paragraph>
    </div>
    <div class="flex flex-wrap justify-around m-auto w-11/12 lg:mb-12 lg:w-8/12">
      <div class="mb-4 lg:flex lg:flex-col lg:items-center w-128">
        <app-paragraph-with-img
          [imgSrc]="'/assets/img/articles/api1.png'"
          [nicerHeader]="'API Integration'"
          [paragraph]="apiIntegrationP"
        >
        </app-paragraph-with-img>
        <a
          href="https://coinmate.docs.apiary.io/#reference"
          target="_blank"
          class="w-full lg:w-auto btn btn-lg btn-outline"
          translate
        >
          developers.go-to-apiary
        </a>
      </div>
      <div class="mb-4 lg:flex lg:flex-col lg:items-center w-128">
        <app-paragraph-with-img
          [imgSrc]="'/assets/img/articles/api2.png'"
          [nicerHeader]="'XChange Java library'"
          [paragraph]="xchangeLibraryP"
        ></app-paragraph-with-img>
        <a
          href="https://github.com/knowm/XChange"
          target="_blank"
          class="w-full lg:w-auto btn btn-lg btn-outline"
          translate
        >
          developers.go-to-github
        </a>
      </div>
    </div>
    <div class="bg-app-slight-grey">
      <div
        class="py-4 my-4 mx-auto w-11/12 text-center lg:flex lg:flex-col lg:items-center lg:py-12 lg:my-16 lg:w-6/12"
      >
        <app-paragraph [paragraph]="apiForBanksP"></app-paragraph>
        <a [routerLink]="['/support'] | localize" class="w-full lg:w-auto btn btn-lg" translate>
          shared.common.contact-us
        </a>
      </div>
    </div>
    <div class="flex flex-wrap justify-around m-auto my-4 w-11/12 lg:my-24 lg:w-8/12">
      <div class="text-center lg:flex lg:flex-col lg:items-center w-128">
        <app-paragraph [paragraph]="bitForMerchP"></app-paragraph>
        <a href="https://confirmo.net/home" target="_blank" class="w-full lg:w-auto btn btn-lg btn-outline">
          confirmo.net
        </a>
      </div>
      <div class="w-128">
        <app-paragraph [paragraph]="bitAtmP"></app-paragraph>
      </div>
    </div>
    <hr />
    <div class="py-8 text-center lg:flex lg:justify-center lg:py-12 lg:text-left">
      <img src="/assets/img/robot.png" alt="robot" class="object-contain pt-3 mx-auto lg:mr-12 lg:ml-0" />
      <app-paragraph [paragraph]="tradingBotsP"></app-paragraph>
    </div>
  </div>
</app-public-with-header>
